import { PreviewContentVariablesContext } from 'providers/PreviewContentVariablesContext';
import { PreviewGridContentPage } from './PreviewGridContentPage';
import { ContentSectionsProvider } from './useContentSectionsForPreview';

export function TemplatePreview({ contentId }: { contentId: string }) {
  return (
    <ContentSectionsProvider contentId={contentId}>
      <PreviewContentVariablesContext.Provider
        value={{
          variables: [],
          updateVariable: () => {
            // do nothing
          },
        }}
      >
        <PreviewGridContentPage contentId={contentId} />
      </PreviewContentVariablesContext.Provider>
    </ContentSectionsProvider>
  );
}
